import _classCallCheck from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Map from "./map.js";
/**
 * @class Simple empty rectangular room
 * @augments ROT.Map
 */
var Arena = /*#__PURE__*/function (_Map) {
  _inherits(Arena, _Map);
  var _super = _createSuper(Arena);
  function Arena() {
    _classCallCheck(this, Arena);
    return _super.apply(this, arguments);
  }
  _createClass(Arena, [{
    key: "create",
    value: function create(callback) {
      var w = this._width - 1;
      var h = this._height - 1;
      for (var i = 0; i <= w; i++) {
        for (var j = 0; j <= h; j++) {
          var empty = i && j && i < w && j < h;
          callback(i, j, empty ? 0 : 1);
        }
      }
      return this;
    }
  }]);
  return Arena;
}(Map);
export { Arena as default };